<template>
<div class="rotage-box">
    <div class="wrap">
        <div class="box1 box">CSS</div>
        <div class="box2 box">SMUI</div>
        <div class="box3 box">VUE</div>
        <div class="box4 box">Webpack</div>
        <div class="box5 box">Node</div>
        <div class="box6 box">HTML5</div>
    </div>
</div>
</template>

<script type="text/javascript">
export default {
    desc: '定义统一的前端组件',
}
</script>

<style type="text/css" lang="less">

@box-width: 80px;
@semi-width: @box-width / 2;

@-webkit-keyframes boxspin {
    0%{
        -webkit-transform:rotateX(0deg) rotateY(0deg) rotateZ(0deg);
        -webkit-transform-origin: center center;
    }
    100%{
        -webkit-transform:rotateX(180deg) rotateY(180deg) rotateZ(180deg);
        -webkit-transform-origin: center center; 
    }
}

@-moz-keyframes boxspin {
    0%{
        -moz-transform:rotateX(0deg) rotateY(0deg) rotateZ(0deg);
        -webkit-transform-origin: center center;
    }
    100% {
        -moz-transform:rotateX(180deg) rotateY(180deg) rotateZ(180deg); 
        -webkit-transform-origin: center center;
    }
}

.rotage-box {
    position: relative;
    min-width: 100px;
    min-height: 100px;
    padding: @semi-width;

    *{
        margin: 0;
        padding: 0;
    }

    .wrap{
          height: 100%;position: relative;
          -webkit-transform-style: preserve-3d;
          -webkit-perspective:0px;
          -moz-transform-style: preserve-3d;
          -moz-perspective: 0px;
          -webkit-animation: boxspin 5s ease infinite;
          -moz-animation: boxspin 5s ease infinite;
    }

    .box {
        width: @box-width;
        height: @box-width;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -@semi-width 0 0 -@semi-width;
        line-height: @box-width;
        text-align: center;
        font-size: @semi-width / 3;
        color: white;
    }
    .box1{
        -webkit-transform:rotatey(90deg) translatez(-@semi-width);
        -moz-transform:rotatey(90deg) translatez(-@semi-width);
        background: rgba(128,0,128,.5);
    }
    .box2{
        -webkit-transform:rotatey(90deg) translatez(@semi-width);
        -moz-transform:rotatey(90deg) translatez(@semi-width);
        background: rgba(255,0,255,.5);
    }
    .box3{
        -webkit-transform:rotatex(90deg) translatez(@semi-width);
        -moz-transform:rotatex(90deg) translatez(@semi-width);
        background: rgba(255,153,204,.5);
    }
    .box4{
        -webkit-transform:rotatex(90deg) translatez(-@semi-width);
        -moz-transform:rotatex(90deg) translatez(-@semi-width);
        background: rgba(0,204,255,.5);
    }
    .box5{
        -webkit-transform: translatez(-@semi-width);
        -moz-transform:translatez(-@semi-width);
        background: rgba(153,204,255,.5);
    }
    .box6{
        -webkit-transform: translatez(@semi-width);
        -moz-transform:translatez(@semi-width);
        background: rgba(0,255,255,.5);
    }
}
</style>


// WEBPACK FOOTER //
// RotageBox.vue?70cad6af